import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { Show } from "@clerk/react";
import { useSettings } from "@/lib/settings";
import { waLink } from "@/lib/api";

export default function SiteFooter() {
  const { settings } = useSettings();
  return (
    <footer className="border-t border-white/10 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 flex flex-col md:flex-row gap-6 md:items-center md:justify-between">
        <div>
          <p className="font-display text-2xl font-black uppercase italic">Lensa<span className="text-[#FF5A00]">Juara</span></p>
          <p className="text-neutral-400 text-sm tracking-[0.2em]">Setiap Perjuangan Layak Diabadikan.</p>
        </div>
        <div className="flex flex-wrap gap-4 items-center text-sm text-neutral-400">
          {settings && (
            <a data-testid="footer-wa-link" href={waLink(settings.whatsapp_number)} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-white transition-colors">
              <MessageCircle className="w-4 h-4 text-emerald-400" /> {settings.whatsapp_number}
            </a>
          )}
          <Show when="signed-out"><Link to="/admin" data-testid="footer-admin-link" className="hover:text-white transition-colors">Login Admin</Link></Show>
        </div>
      </div>
    </footer>
  );
}
